import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Shield } from "lucide-react";

export default function Privacy() {
  return (
    <div className="App">
      <Header />
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-10 space-y-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: "rgba(59,86,224,0.15)", color: "var(--brand)" }}>
            <Shield className="w-5 h-5" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Informativa</div>
            <h1 className="display font-black text-3xl md:text-4xl">Privacy Policy</h1>
          </div>
        </div>
        <div className="card-surface rounded-2xl p-6 md:p-8 space-y-4 text-slate-700 text-[15px] leading-relaxed">
          <p><b>Titolare</b>: Federazione Italiana Fantaleghe Elite (FIFE) — C.F. 94159600306, Udine.</p>
          <p><b>Dati raccolti</b>: email, nome e cognome, numero di telefono e girone di appartenenza forniti in fase di registrazione. Cookie tecnici e di misurazione anonima per il funzionamento del portale.</p>
          <p><b>Finalità</b>: gestione delle iscrizioni al torneo, comunicazioni relative alle giornate, invio della newsletter (solo previa iscrizione).</p>
          <p><b>Diritti dell'utente</b>: puoi in qualsiasi momento chiedere l'accesso, la rettifica o la cancellazione dei dati scrivendo all'indirizzo indicato in Chi Siamo. Il consenso ai cookie può essere revocato tramite il banner in fondo alla pagina.</p>
          <p><b>Conservazione</b>: i dati sono conservati per la durata dell'iscrizione al torneo e per gli anni successivi previsti dalla normativa fiscale.</p>
          <p className="text-slate-500 text-xs">Documento informativo semplificato — per la versione integrale contatta la FIFE.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
